import React, { useCallback, useEffect } from "react";
import "./EditorialLayout.css";
import hero from "../../assets/img/blogs/hero.png"
import ImageSlider from "./ImageSlider";
import { hideEditorialLayout, setBlogData, setSingleBlogData, showBlog, showHeroBanner } from "../../features/serviceSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const EditorialLayout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {
        isIndividualBlog,
        blog_data
    } = useSelector(state => state.service);

    const fetchData = useCallback(async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_CUSTOM_API+"/blogs"
            );
            dispatch(setBlogData(response.data));
            dispatch(setSingleBlogData(response.data?.latest?.[0] || null)); // set the first blog as default single blog data

        } catch (error) {
            console.error("API error:", error);
        }
    }, [dispatch]);

    function formatDate(dateString) {
        const date = new Date(dateString);

        const day = date.getDate();
        const month = date.toLocaleString("en-GB", { month: "long" });
        const year = date.getFullYear();

        return `${month} ${day}, ${year}`;
    }

    useEffect(() => {
        fetchData();
    }, [fetchData]);
    return (
        <div className="editorial-wrapper">
            <button
                type="button"
                className="editorial-close-btn"
                onClick={(event) => {
                    event.stopPropagation();
                    dispatch(hideEditorialLayout());
                    dispatch(showHeroBanner());
                    navigate("/services");
                }}
            >
                &#10005; Close
            </button>

            {/* Left Filter */}


            {/* Center Content */}
            <main className="editorial-content">

                <div className="d-flex space-between">
                    <aside className="filter">
                        <span className="">FILTER</span>
                    </aside>

                    <div className="w-70">{/* Top Categories */}
                        <nav className="categories">
                            <ul>
                                <li className="active">ALL</li>
                                <li>WARDROBE INTELLIGENCE</li>
                                <li>THE ESTATES EDIT</li>
                                <li>ON BOARD AND AIRBORNE</li>
                                <li>THE WEEKEND SET</li>
                                <li>CULTURE, CONSIDERED</li>
                            </ul>
                        </nav>

                        {/* Hero */}
                        <section className="hero">
                            <img
                                src={
                                    blog_data?.latest?.length > 0
                                        ? blog_data.latest[0].featured_image
                                        : hero
                                }
                                alt="Hero"
                                className="hero-image"
                                onClick={(e) => {
                                    if (!isIndividualBlog) {
                                        e.stopPropagation();

                                        const latestBlog = blog_data?.latest?.[0];

                                        if (!latestBlog) return; // safety guard

                                        dispatch(showBlog(1));
                                        dispatch(setSingleBlogData(latestBlog));
                                    }
                                }}

                            />

                            <div className="hero-text">
                                <span className="date">
                                    {blog_data?.latest?.[0]?.date
                                        ? formatDate(blog_data.latest[0].date)
                                        : ""}
                                </span>

                                <h1>
                                    {blog_data?.latest?.[0]?.title}
                                </h1>
                                <span className="author">
                                    {blog_data?.latest?.[0]?.author?.name
                                        ? `by ${blog_data.latest[0].author.name}`
                                        : ""}
                                </span>

                            </div>
                        </section></div>
                </div>

                {/* December */}
                <section className="month-section">
                    <div className="month-text">
                        <h2>{blog_data?.current_month?.label || ""}</h2>
                        <em>{blog_data?.current_month?.tagline || ""}</em>
                        <p>
                            {blog_data?.current_month?.paragraph || ""}
                        </p>

                    </div>

                    <ImageSlider slider={"current_month"} />
                </section>

                {/* November */}
                <section className="month-section">
                    <div className="month-text">
                        <h2>{blog_data?.last_month?.label || ""}</h2>
                        <em>{blog_data?.last_month?.tagline || ""}</em>
                        <p>
                            {blog_data?.last_month?.paragraph || ""}
                        </p>

                    </div>

                    <ImageSlider slider={"last_month"} />
                </section>

            </main>

            {/* Right Vertical Label */}
            <aside className="vertical-label side-vertical-heading top-p-40">
                <span>DECEMBER 2025</span> <span className="spacer"></span> <span>THE PRIVATE STANDARD (A BLOG)</span>
            </aside>

        </div>
    );
};

export default EditorialLayout;
